import React from 'react';

import { Breadcrumbs } from '@benzinga/core-ui';
import { WordpressPost } from '@benzinga/content-manager';

import styles from './MoneyPostBreadcrumbs.module.css';

export interface MoneyPostBreadCrumbsProps {
  post: WordpressPost;
}

export const MoneyPostBreadcrumbs: React.FC<MoneyPostBreadCrumbsProps> = ({ post }) => {
  if (!post.breadcrumbs) return null;
  return (
    <div className={`${styles.wrapper} mb-2.5`}>
      <Breadcrumbs data={post.breadcrumbs} separator="/" />
    </div>
  );
};
